import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import { TvLoginForm } from "../features/auth/tv/components/tv-login-form";
import classes from "../components/Form/Form.module.css";
import tvFormClasses from "../features/auth/tv/components/TvLoginForm.module.css";

export default function TvLogin() {
	const { t } = useTranslation();

	return (
		<>
			<Helmet>
				<title>{t("metadata.tvLogin.title")}</title>
				<meta name="description" content={t("metadata.tvLogin.description")} />
			</Helmet>
			<div className={classes.authContainer}>
				<div className={classes.authFormContainer}>
					<h1 className={`${classes.formHeader} font-700`}>{t("tvLogin.title")}</h1>
					<p className={tvFormClasses.subtitle}>{t("tvLogin.subtitle")}</p>
					<TvLoginForm />
				</div>
			</div>
		</>
	);
}
